import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { FaqsListComponent } from '@adm-web-app/modules/faqs/list/list.component';
import { FaqEditComponent } from '@adm-web-app/modules/faqs/edit/edit.component';
import { FaqModel, HxFaqService } from 'hx-services';

const faqResolveFn: ResolveFn<FaqModel> = route => inject(HxFaqService).getFaqById(Number(route.paramMap.get('id')));

export const faqRoutes: Routes = [
  {
    path: '', component: FaqsListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: FaqEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: FaqEditComponent,
    resolve: {
      model: faqResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
